import { zodResolver } from '@hookform/resolvers/zod';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { login } from '../../../apis/sign_in';
import { UserInfo, useAuth } from '../../../components/auth/AuthProvider';
import { getPaymentReportLink } from '../../../utils/getLinks';
import { LoginFormFieldValues, loginSchema } from '../logics/schema';
import { IUseLoginModal } from '../types';

export const useLoginModal: IUseLoginModal = () => {
  const { signIn } = useAuth();
  const navigate = useNavigate();
  const [errMsg, setErrMsg] = useState<string>('');

  const methods = useForm<LoginFormFieldValues>({
    defaultValues: {
      email: '',
      password: '',
    },
    criteriaMode: 'all',
    mode: 'onChange',
    resolver: zodResolver(loginSchema),
  });

  const handleSubmit = methods.handleSubmit(async ({ email, password }) => {
    try {
      const response = await login({
        company_admin_user: {
          email,
          password,
        },
      });
      const data = await response.json();
      const userInfo = data as UserInfo;
      signIn(userInfo);
      navigate(getPaymentReportLink());
    } catch {
      setErrMsg('ログインできませんでした。ネットワークの状態を確認し、もう一度お試しください。');
    }
  });

  const { isValid, isSubmitting } = methods.formState;
  const buttonDisabled = !isValid || isSubmitting;

  return {
    state: {
      methods,
      errMsg,
      buttonDisabled,
    },
    actions: {
      handleSubmit,
      setErrMsg,
    },
  };
};
